import { createFileRoute } from '@tanstack/react-router'
import { ListVetPage } from '_/features/pets/ui/pages/list-vet-page'

export const Route = createFileRoute('/_authenticated/pets/vets/')({
	staticData: { title: 'vets_title' },
	component: ListVetPage,
})
